import React from "react";
import { useHistory } from 'react-router-dom';

export default function Footer() {
  const history = useHistory();
  return (
    <footer className="bg-white px-4 sm:px-6 md:px-8 lg:px-4 xl:px-4 py-8 md:py-12 lg:py-16 xl:py-[40px]">
      <div className="max-w-[1400px] mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr_250px] gap-4  items-start mb-8 md:mb-12 lg:mb-16 xl:mb-[40px]">

          {/* Left Column - Logo and Description */}
          <div className="flex flex-col items-start">
            <div className="w-[60px] h-[52px] sm:w-[68px] sm:h-[58px] md:w-[74px] md:h-[64px] mb-4 md:mb-6 lg:mb-8 xl:mb-[20px]">
              <img
                src="/assets/landing-2025/magikk-logo-simple.svg"
                alt="Magikk Symbol"
                className="w-full h-full"
              />
            </div>
            <p className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] text-[#002342] leading-relaxed mb-4 md:mb-6 lg:mb-8 xl:mb-[20px] max-w-[280px]">
              social tech que potencializa<br/>estratégias de impacto.
            </p>
            <div className="flex gap-3 sm:gap-4 md:gap-5 lg:gap-6 xl:gap-[13px] items-center">
              <a 
              onClick={() => window.open('https://www.facebook.com/magikkarma')}
               className="w-[11px] h-[19px] hover:opacity-70 transition-opacity">
                <img src="/assets/landing-2025/facebook-icon.svg" alt="Facebook" className="w-full h-full" />
              </a>
              <a
              onClick={() => window.open('https://www.instagram.com/magikkarma')}
               className="w-[19px] h-[19px] hover:opacity-70 transition-opacity">
                <img src="/assets/landing-2025/instagram-icon.svg" alt="Instagram" className="w-full h-full" />
              </a>
              <a 
              onClick={() => window.open('https://www.linkedin.com/company/magikk-co/')}
               className="w-[19px] h-[18px] hover:opacity-70 transition-opacity">
                <img src="/assets/landing-2025/linkedin-icon.svg" alt="LinkedIn" className="w-full h-full" />
              </a>
              <a 
              onClick={() => window.open('https://www.youtube.com/@magikkarma')}
               className="w-[21px] h-[15px] hover:opacity-70 transition-opacity">
                <img src="/assets/landing-2025/youtube-icon.svg" alt="YouTube" className="w-full h-full" />
              </a>
            </div>
          </div>

          {/* Center Column - Action Buttons Section */}
          <div className="order-3 lg:order-2 col-span-1 md:col-span-2 lg:col-span-1">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3  xl:gap-[32px]">

              {/* Parceiro Empresarial */}
              <div className="text-center">
                <h4 className="font-raleway font-medium text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] text-[#002342] mb-3 sm:mb-4 md:mb-5 lg:mb-6 xl:mb-[16px]">
                  Parceiro Empresarial (B2B)
                </h4>
                <button 
                onClick={() => history.push('/company-form-2025')}
                className="bg-[#002342] text-white px-4 sm:px-5 md:px-6 lg:px-7 xl:px-[20px] py-2 sm:py-3 md:py-4 lg:py-5 xl:py-[8px] rounded-[16px] sm:rounded-[18px] md:rounded-[20px] lg:rounded-[22px] xl:rounded-[20px] font-raleway font-medium text-xs sm:text-sm md:text-base lg:text-lg xl:text-[12px] hover:bg-[#85C4FF] transition-all duration-300 w-full max-w-[140px] sm:max-w-[120px] md:max-w-[140px] lg:max-w-[160px] xl:max-w-[140px] text-center whitespace-nowrap">
                  Fale com a magikk
                </button>
              </div>

              {/* ONG ou Captador */}
              <div className="text-center">
                <h4 className="font-raleway font-medium text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] text-[#002342] mb-3 sm:mb-4 md:mb-5 lg:mb-6 xl:mb-[16px]">
                  ONG
                </h4>
                <button 
                onClick={() => history.push('/market?category=causes')}
                className="bg-[#C684F5] text-white px-4 sm:px-5 md:px-6 lg:px-7 xl:px-[20px] py-2 sm:py-3 md:py-4 lg:py-5 xl:py-[8px] rounded-[16px] sm:rounded-[18px] md:rounded-[20px] lg:rounded-[22px] xl:rounded-[20px] font-raleway font-medium text-xs sm:text-sm md:text-base lg:text-lg xl:text-[12px] hover:bg-[#B574E5] transition-all duration-300 w-full max-w-[140px] sm:max-w-[120px] md:max-w-[140px] lg:max-w-[160px] xl:max-w-[140px] text-center whitespace-nowrap">
                  Acesse o HUB
                </button>
              </div>

              {/* Desenvolvedor ou Plataforma */}
              <div className="text-center">
                <h4 className="font-raleway font-medium text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] text-[#002342] mb-3 sm:mb-4 md:mb-5 lg:mb-6 xl:mb-[16px]">
                  Usuário
                </h4>
                <button 
                onClick={() => window.open('https://apps.apple.com/br/app/magikk-goods-and-good-deeds/id1502548875')}
                className="bg-[#002342] text-white px-4 sm:px-5 md:px-6 lg:px-7 xl:px-[20px] py-2 sm:py-3 md:py-4 lg:py-5 xl:py-[8px] rounded-[16px] sm:rounded-[18px] md:rounded-[20px] lg:rounded-[22px] xl:rounded-[20px] font-raleway font-medium text-xs sm:text-sm md:text-base lg:text-lg xl:text-[12px] hover:bg-[#85C4FF] transition-all duration-300 w-full max-w-[140px] sm:max-w-[120px] md:max-w-[140px] lg:max-w-[160px] xl:max-w-[140px] text-center whitespace-nowrap">
                  Baixe o APP
                </button>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Info */}
          <div className="order-2 lg:order-3 pl-4">
            <h3 className="font-raleway font-semibold text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[18px] text-[#002342] mb-4 md:mb-6 lg:mb-8 xl:mb-[24px]">
              Entre em contato
            </h3>
            <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6 xl:space-y-[12px]">
              <div className="flex items-start gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-[6px] text-[#002342]">
                <div className="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px] mt-1 flex-shrink-0">
                  <svg viewBox="0 0 20 20" className="w-full h-full">
                    <path d="M1.67 3.87h16.67v12.5H1.67V3.87z" stroke="#85C4FF" strokeWidth="1.4" fill="none"/>
                    <path d="M1.67 6.91l8.33 6.25 8.33-6.25" stroke="#85C4FF" strokeWidth="1.4" fill="none"/>
                  </svg>
                </div>
                <span className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px]">comercial@magikk.com</span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-[6px] text-[#002342]">
                <div className="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px] mt-1 flex-shrink-0">
                  <svg viewBox="0 0 20 20" className="w-full h-full">
                    <rect x="1.67" y="1.37" width="16.67" height="16.67" rx="2" stroke="#85C4FF" strokeWidth="1.4" fill="none"/>
                    <path d="M6.67 8.37h6.67M6.67 11.37h6.67" stroke="#85C4FF" strokeWidth="1.4"/>
                  </svg>
                </div>
                <span className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px]">(21) 99628-6404</span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-[8px] text-[#002342]">
                <div className="w-[16px] h-[20px] sm:w-[18px] sm:h-[22px] md:w-[20px] md:h-[25px] flex items-start mt-1 flex-shrink-0">
                  <svg viewBox="0 0 20 25" className="w-full h-[16px] sm:h-[18px] md:h-[20px]">
                    <path d="M10 1C6.13 1 3 4.13 3 8c0 5.25 7 15 7 15s7-9.75 7-15c0-3.87-3.13-7-7-7z" stroke="#85C4FF" strokeWidth="1.4" fill="none"/>
                    <circle cx="10" cy="8" r="3" stroke="#85C4FF" strokeWidth="1.4" fill="none"/>
                  </svg>
                </div>
                <div>
                  <p className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] leading-relaxed">
                    Av. das Américas, 8585<br/>
                    Barra da Tijuca<br/>
                    Rio de Janeiro - RJ
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#D9DBE9] mb-4 md:mb-6 lg:mb-8 xl:mb-[20px]"></div>

        {/* Footer Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6 md:gap-8 text-[#002342]">
          <span className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px]">Copyright © 2025</span>
          <div className="font-raleway text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] text-center sm:text-right">
            <span>Todos os direitos reservados | </span>
            <a onClick={() => history.push('/term-of-use')} className="text-[#85C4FF] hover:underline cursor-pointer">Termos de Uso</a>
            <span> | </span>
            <a
            onClick={() => history.push('/privacy-policy')}
             className="text-[#85C4FF] hover:underline cursor-pointer">Política de Privacidade</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
